import { render } from "./resource.vue?vue&type=template&id=7dffd3b4&scoped=true"
import script from "./resource.vue?vue&type=script&lang=js"
export * from "./resource.vue?vue&type=script&lang=js"

import "./resource.vue?vue&type=style&index=0&id=7dffd3b4&lang=scss&scoped=true"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dffd3b4"]])

export default __exports__